import { Filter } from '@anytag/shared-molecules';
import { Template } from './Template';
import { useUsersFilter } from './hooks';

export const UsersFilter = () => {
  const { filter, setFilterForm } = useUsersFilter();

  return (
    <Filter.Provider onSubmit={setFilterForm} values={filter}>
      <Template />
    </Filter.Provider>
  );
};

export { useUsersFilter };
export * from './schemaTypes';
